import {AuthService} from "../services/AuthService";
import {useAppSelector} from "../store/hooks";
import {redirect, Route, Navigate, Outlet, useNavigate} from "react-router-dom";
import {authAPI} from "../api/auth";
import React, {useEffect} from "react";

export const PrivateRoute = () => {
    const navigate = useNavigate()
    const storageToken = AuthService.getToken() || ''
    const [validate, {isLoading, isError, isSuccess}] = authAPI.useValidateMutation()
    const {authUser} = useAppSelector(state => state.auth)

    useEffect(() => {
        if (isSuccess && !authUser && !isLoading) {
            navigate('/login')
        }
    }, [authUser])

    useEffect(() => {
        if (!storageToken && !isLoading) {
            navigate('/login')
            return;
        }

        if (storageToken) {
            validate()
        }

    }, [])

    useEffect(() => {
        if (isError && !isLoading) {
            navigate('/login')
            return;
        }

    }, [isError])

    return authUser ? <Outlet /> : <></>;
}